import styled from 'styled-components';
export const StyledTypography = styled.span `
  margin: 0;
  padding: 0;
  border: 0;
  ${({ theme, $variant }) => theme.typography[$variant]};
`;
//# sourceMappingURL=BKJTypography.styled.js.map